import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Tab, Tabs, OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import TimesheetOvertimeConfigurations from '../../Schedule/UrgentCallManagement/TimesheetOvertimeConfigurations';

//elements
import SwitchWidget from '../SwitchWidget';

//utils
import { getCompanyOvertimeTypes } from '~/utils/commonMethods';

class UrgentWorkSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            urgentWorkSettings: {
                allowUrgentWork: false,
                allowUrgentWorkForMembers: false,
                allowMinHoursForFieldWork: false,
                allowMinHoursForCustomerCare: false,
                allowAdditionalPaymentsForUrgentWorkTimesheets: false,
                allowUrgentCallWithAbsence: false,
                allowUrgentCallWithVacation: false,
                defaultFieldWorkTimesheetConfigs: [],
                defaultHolidayFieldWorkTimesheetConfigs: [],
                defaultCustomerCareTimesheetConfigs: [],
                defaultHolidayCustomerCareTimesheetConfigs: [],
                allowStandbyCalls: false,
                allowSyncingFieldOperativeUrgentWorkToIntegration: false,
                allowStandbySyncForHourlySalary: true,
                allowStandbySyncForFixedSalary: false,
            }
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        const { urgentWorkSettings } = this.state;
        if (currentEntity.client && currentEntity.client.data && currentEntity.client.data.basicRules && currentEntity.client.data.basicRules.urgentWorkSettings) {
            const _urgentWorkSettings = Object.assign({}, currentEntity.client.data.basicRules.urgentWorkSettings);
            urgentWorkSettings.allowUrgentWork = _urgentWorkSettings.allowUrgentWork ? _urgentWorkSettings.allowUrgentWork : false;
            urgentWorkSettings.allowMinHoursForFieldWork = _urgentWorkSettings.allowMinHoursForFieldWork ? _urgentWorkSettings.allowMinHoursForFieldWork : false;
            urgentWorkSettings.allowMinHoursForCustomerCare = _urgentWorkSettings.allowMinHoursForCustomerCare ? _urgentWorkSettings.allowMinHoursForCustomerCare : false;
            urgentWorkSettings.allowAdditionalPaymentsForUrgentWorkTimesheets = _urgentWorkSettings.allowAdditionalPaymentsForUrgentWorkTimesheets ? _urgentWorkSettings.allowAdditionalPaymentsForUrgentWorkTimesheets : false;
            urgentWorkSettings.allowUrgentCallWithAbsence = _urgentWorkSettings.allowUrgentCallWithAbsence ? _urgentWorkSettings.allowUrgentCallWithAbsence : false;
            urgentWorkSettings.allowUrgentCallWithVacation = _urgentWorkSettings.allowUrgentCallWithVacation ? _urgentWorkSettings.allowUrgentCallWithVacation : false;
            urgentWorkSettings.defaultFieldWorkTimesheetConfigs = _urgentWorkSettings.defaultFieldWorkTimesheetConfigs ? _urgentWorkSettings.defaultFieldWorkTimesheetConfigs : [];
            urgentWorkSettings.defaultHolidayFieldWorkTimesheetConfigs = _urgentWorkSettings.defaultHolidayFieldWorkTimesheetConfigs ? _urgentWorkSettings.defaultHolidayFieldWorkTimesheetConfigs : [];
            urgentWorkSettings.defaultCustomerCareTimesheetConfigs = _urgentWorkSettings.defaultCustomerCareTimesheetConfigs ? _urgentWorkSettings.defaultCustomerCareTimesheetConfigs : [];
            urgentWorkSettings.defaultHolidayCustomerCareTimesheetConfigs = _urgentWorkSettings.defaultHolidayCustomerCareTimesheetConfigs ? _urgentWorkSettings.defaultHolidayCustomerCareTimesheetConfigs : [];
            urgentWorkSettings.allowStandbyCalls = _urgentWorkSettings.allowStandbyCalls ? _urgentWorkSettings.allowStandbyCalls : false;
            urgentWorkSettings.allowUrgentWorkForMembers = _urgentWorkSettings.allowUrgentWorkForMembers ? _urgentWorkSettings.allowUrgentWorkForMembers : false;
            urgentWorkSettings.allowSyncingFieldOperativeUrgentWorkToIntegration = _urgentWorkSettings.allowSyncingFieldOperativeUrgentWorkToIntegration ? _urgentWorkSettings.allowSyncingFieldOperativeUrgentWorkToIntegration : false;
            urgentWorkSettings.allowStandbySyncForHourlySalary = _urgentWorkSettings.allowStandbySyncForHourlySalary ? _urgentWorkSettings.allowStandbySyncForHourlySalary : false;
            urgentWorkSettings.allowStandbySyncForFixedSalary = _urgentWorkSettings.allowStandbySyncForFixedSalary ? _urgentWorkSettings.allowStandbySyncForFixedSalary : false;
            this.setState({ urgentWorkSettings });
        }
    }

    handleSwitch = (name, value) => {
        const { urgentWorkSettings } = this.state;
        if (name !== 'allowUrgentWork' && !urgentWorkSettings.allowUrgentWork) return;
        if (!value && name === 'allowMinHoursForFieldWork') {
            urgentWorkSettings.defaultFieldWorkTimesheetConfigs = urgentWorkSettings.defaultFieldWorkTimesheetConfigs.map(config => ({ ...config, min_hours_in_mins: 0 }));
            urgentWorkSettings.defaultHolidayFieldWorkTimesheetConfigs = urgentWorkSettings.defaultHolidayFieldWorkTimesheetConfigs.map(config => ({ ...config, min_hours_in_mins: 0 }));
        }
        if (!value && name === 'allowMinHoursForCustomerCare') {
            urgentWorkSettings.defaultCustomerCareTimesheetConfigs = urgentWorkSettings.defaultCustomerCareTimesheetConfigs.map(config => ({ ...config, min_hours_in_mins: 0 }));
            urgentWorkSettings.defaultHolidayCustomerCareTimesheetConfigs = urgentWorkSettings.defaultHolidayCustomerCareTimesheetConfigs.map(config => ({ ...config, min_hours_in_mins: 0 }));
        }
        urgentWorkSettings[name] = value;
        this.props.handleUserDataChange('urgentWorkSettings', urgentWorkSettings);
        this.setState({ urgentWorkSettings });
    }

    configKeyMap = {
        fieldwork_weekday: 'defaultFieldWorkTimesheetConfigs',
        fieldwork_holiday: 'defaultHolidayFieldWorkTimesheetConfigs',
        customercare_weekday: 'defaultCustomerCareTimesheetConfigs',
        customercare_holiday: 'defaultHolidayCustomerCareTimesheetConfigs'
    }

    updateDefaultConfigs = (key, timesheetConfigs) => {
        const stateKey = this.configKeyMap[key];
        if (!stateKey) return;
        const { urgentWorkSettings } = this.state;
        urgentWorkSettings[stateKey] = timesheetConfigs;
        this.props.handleUserDataChange('urgentWorkSettings', urgentWorkSettings);
        this.setState({ urgentWorkSettings });
    }

    render() {
        const { urgentWorkSettings } = this.state;
        const { t, commonStore } = this.props;
        const overtimeTypes = getCompanyOvertimeTypes(commonStore.config.client, commonStore.config.overtimes, false);

        return (
            <div>
                <Row className='mt-2'>
                    <label className="control-label font-size-15 mt-2 font-color-primary">{t('Urgent Work Settings')}</label>
                </Row>
                <hr />
                <Row>
                    <Col xs={10}>
                        <Row className='align-items-center mb-1'>
                            <Col xs={7}>
                                <label className="control-label">{t('Allow Urgent Work')}
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("This feature helps you manage urgent work for employees and the compensation for employees working on urgent work")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={5}>
                                <SwitchWidget
                                    value={urgentWorkSettings.allowUrgentWork}
                                    onChange={checked => this.handleSwitch('allowUrgentWork', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='align-items-center mb-1'>
                            <Col xs={7}>
                                <label className="control-label">{t('Allow Additional Payments for Urgent Work Timesheets')}
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t('When enabled, additional payments are calculated for urgent work timesheets. When disabled, urgent work timesheets are not included in additional payment calculations.')}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={5}>
                                <SwitchWidget
                                    value={urgentWorkSettings.allowAdditionalPaymentsForUrgentWorkTimesheets}
                                    disabled={!urgentWorkSettings.allowUrgentWork}
                                    onChange={checked => this.handleSwitch('allowAdditionalPaymentsForUrgentWorkTimesheets', checked)} />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={2}>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col xs={6}>
                        <Row >
                            <label className="control-label font-size-15 mt-2 font-color-primary">{t('Timesheet Registration with Minimum Hours')}</label>
                        </Row>
                        <hr />
                        <Row className='align-items-center mb-1'>
                            <Col xs={10}>
                                <label className="control-label">{t('Apply min. hours for Urgent Work (Field Operative)')}
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If enabled then the minimum hours defined in the control panel will be applied for field work urgent work overtime")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={2}>
                                <SwitchWidget
                                    value={urgentWorkSettings.allowMinHoursForFieldWork}
                                    disabled={!urgentWorkSettings.allowUrgentWork}
                                    onChange={checked => this.handleSwitch('allowMinHoursForFieldWork', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='align-items-center mb-1'>
                            <Col xs={10}>
                                <label className="control-label">{t('Apply min. hours for Urgent Work (Customer Care)')}
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t('If enabled then the minimum hours defined in the control panel will be applied for customer care urgent work overtime')}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={2}>
                                <SwitchWidget
                                    value={urgentWorkSettings.allowMinHoursForCustomerCare}
                                    disabled={!urgentWorkSettings.allowUrgentWork}
                                    onChange={checked => this.handleSwitch('allowMinHoursForCustomerCare', checked)} />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6}>
                        <Row >
                            <label className="control-label font-size-15 mt-2 font-color-primary">{t('Urgent Work on Absence/Vacations')}</label>
                        </Row>
                        <hr />
                        <Row className='align-items-center mb-1'>
                            <Col xs={10}>
                                <label className="control-label">{t('Allow Urgent Work with Absence')}
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t('When enabled, urgent work timesheets can be registered even if an absence exists for the same day, and absences can be registered even if an urgent work timesheet exists.')}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={2}>
                                <SwitchWidget
                                    value={urgentWorkSettings.allowUrgentCallWithAbsence}
                                    disabled={!urgentWorkSettings.allowUrgentWork}
                                    onChange={checked => this.handleSwitch('allowUrgentCallWithAbsence', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='align-items-center mb-1'>
                            <Col xs={10}>
                                <label className="control-label">{t('Allow Urgent Work with Vacation')}
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t('When enabled, urgent work timesheets can be registered even if a vacation exists for the same day, and vacations can be registered even if an urgent work timesheet exists.')}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={2}>
                                <SwitchWidget
                                    value={urgentWorkSettings.allowUrgentCallWithVacation}
                                    disabled={!urgentWorkSettings.allowUrgentWork}
                                    onChange={checked => this.handleSwitch('allowUrgentCallWithVacation', checked)} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={5}>
                        <label className="control-label">{t('Allow Syncing Field Operative Urgent Work to Integration')}</label>
                    </Col>
                    <Col xs={1}>
                        <SwitchWidget
                            value={urgentWorkSettings.allowSyncingFieldOperativeUrgentWorkToIntegration}
                            onChange={checked => this.handleSwitch('allowSyncingFieldOperativeUrgentWorkToIntegration', checked)} />
                    </Col>
                </Row>
                <hr />
                <div className='mt-2'>
                    <Row>
                        <label className="control-label font-size-15 mt-2 mb-1 font-color-primary">{t('Standby Settings')}</label>
                    </Row>
                    <hr />
                    <div className='d-flex'>
                        <Col xs={5}>
                            <label className="control-label">{t('Allow standby calls')}</label>
                        </Col>
                        <Col xs={1}>
                            <SwitchWidget
                                value={urgentWorkSettings.allowStandbyCalls}
                                onChange={checked => this.handleSwitch('allowStandbyCalls', checked)} />
                        </Col>
                    </div>
                    <div className='mt-2 d-flex'>
                        <Col xs={5}>
                            <label className="control-label">{t('Allow syncing standby calls for Hourly users')}</label>
                        </Col>
                        <Col xs={1} className="mt-1">
                            <SwitchWidget
                                value={urgentWorkSettings.allowStandbySyncForHourlySalary}
                                onChange={checked => this.handleSwitch('allowStandbySyncForHourlySalary', checked)} />
                        </Col>
                        <Col xs={5}>
                            <label className="control-label">{t('Allow syncing standby call for fixed salary type')}</label>
                        </Col>
                        <Col xs={1} className="mt-1">
                            <SwitchWidget
                                value={urgentWorkSettings.allowStandbySyncForFixedSalary}
                                onChange={checked => this.handleSwitch('allowStandbySyncForFixedSalary', checked)} />
                        </Col>
                    </div>
                </div>
                <hr />
                {urgentWorkSettings.allowUrgentWork && (
                    <Tabs defaultActiveKey="fieldwork_weekday" id="urgentWorkConfigTabs" className="mt-3">
                        {[
                            { eventKey: 'fieldwork_weekday', title: t('Field Operative') + ' - ' + t('Weekdays'), configTitle: t('Set Default Field Operative Configuration for Weekdays'), timesheetConfigs: urgentWorkSettings.defaultFieldWorkTimesheetConfigs, allowMinHours: urgentWorkSettings.allowMinHoursForFieldWork, defaultMinHours: 120 },
                            { eventKey: 'fieldwork_holiday', title: t('Field Operative') + ' - ' + t('Holiday') + ' / ' + t('Weekend'), configTitle: t('Set Default Field Work Configuration for Holidays & Weekends'), timesheetConfigs: urgentWorkSettings.defaultHolidayFieldWorkTimesheetConfigs, allowMinHours: urgentWorkSettings.allowMinHoursForFieldWork, defaultMinHours: 150 },
                            { eventKey: 'customercare_weekday', title: t('Customer Care') + ' - ' + t('Weekdays'), configTitle: t('Set Default Customer Care Configuration for Weekdays'), timesheetConfigs: urgentWorkSettings.defaultCustomerCareTimesheetConfigs, allowMinHours: urgentWorkSettings.allowMinHoursForCustomerCare, defaultMinHours: 30 },
                            { eventKey: 'customercare_holiday', title: t('Customer Care') + ' - ' + t('Holiday') + ' / ' + t('Weekend'), configTitle: t('Set Default Customer Care Configuration for Holidays & Weekends'), timesheetConfigs: urgentWorkSettings.defaultHolidayCustomerCareTimesheetConfigs, allowMinHours: urgentWorkSettings.allowMinHoursForCustomerCare, defaultMinHours: 30 }
                        ].map(tab => (
                            <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
                                <TimesheetOvertimeConfigurations
                                    overtimeTypes={overtimeTypes}
                                    currentTimesheetConfig={{ key: tab.eventKey, timesheetConfigs: tab.timesheetConfigs }}
                                    updateTimesheetConfigs={this.updateDefaultConfigs}
                                    allowMinHours={tab.allowMinHours}
                                    defaultMinHours={tab.defaultMinHours}
                                    title={tab.configTitle}
                                />
                            </Tab>
                        ))}
                    </Tabs>
                )}
            </div>
        );
    }
}

export default inject('clientStore', 'commonStore')(withLocalization(observer(UrgentWorkSettings)));
